import ITenantInMarket from "../interfaces/ITenantInMarket";
import useFocusShape from "./useFocusShape";
import useTenantsInMarketInsideShape from "./useTenantsInMarketInsideShape";

export default function (tenantsInMarket: ITenantInMarket[]): ITenantInMarket[] {
    return useTenantsInMarketInsideShape(tenantsInMarket, useFocusShape());
}